<template>
  <TaskPerformanceRegionReport
      :items="items"
      @updated="onUpdate"
  />
</template>

<script>

import _ from "underscore"
import Moment from "moment";
import Mapper from "@/mappers"
import {AllowStatistics} from "@/enums/permission";
import ReportService from "@/services/report.service"
import {  LAYOUT_LOADING_START,  LAYOUT_LOADING_STOP,  LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import TaskPerformanceRegionReport from "@/components/report/DeliveryStatistics/TaskPerformanceRegionReportComponent.vue";

export default {
  name: "TaskPerformanceRegionReportView",
  components: {
    TaskPerformanceRegionReport,
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      const {start, end, date, selectedFilters, selectedRegions, isAllClientsSelected, isArchive, clients} = filters;

      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getTaskPerformanceRegionReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        date: date ? Moment(date, "YYYY-MM") : null,
        selectedFilters: selectedFilters ? selectedFilters : null,
        selectedRegions: selectedRegions ? selectedRegions : null,
        isAllClientsSelected: isAllClientsSelected,
        type: isArchive,
        clients: clients
      })
          .then(response => {
            this.items = _.map(response.data, rvm => {
              return {
                region: Mapper.mapRegion(rvm.Region),
                received: rvm.Received,
                notPrintedForPeriodResult: rvm.NotPrintedForPeriodResult,
                notPackedForPeriodResult: rvm.NotPackedForPeriodResult,
                printedForPeriodResult: rvm.PrintedForPeriodResult,
                printedInTimeForPeriodResult: rvm.PrintedInTimeForPeriodResult,
                printedExpiredForPeriodResult: rvm.PrintedExpiredForPeriodResult,
                packedForPeriodResult: rvm.PackedForPeriodResult,
                packedInTimeForPeriodResult: rvm.PackedInTimeForPeriodResult,
                packedExpiredForPeriodResult: rvm.PackedExpiredForPeriodResult
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика пост пакетов по регионам")
    }
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>
